import styled from 'styled-components';

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  gap: 8px;

  width: 100%;
  max-width: 80%;
  padding: 12px 8px;
  padding: ${(props) => (props.isUser ? '8px' : '16px 8px')};
  border-radius: 12px;
  background-color: ${(props) =>
    props.isUser ? props.theme.colors.greys.darkest : props.theme.colors.greys.lightMedium};
  color: ${(props) => (props.isUser ? props.theme.colors.white : props.theme.colors.black)};
  border-bottom-right-radius: ${(props) => (props.isUser ? '0' : '12px')};
  border-bottom-left-radius: ${(props) => (props.isUser ? '12px' : '0')};

  @media (min-width: 1024px) {
    max-width: 70%;
  }
`;

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;

  white-space: pre-wrap;

  justify-content: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};

  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  table {
    border-collapse: collapse;
    background-color: ${(props) =>
      props.isUser ? props.theme.colors.greys.darkest : props.theme.colors.greys.lighter};

    th,
    td {
      border-left: 1px solid ${(props) => props.theme.colors.greys.light};
      border-right: 1px solid ${(props) => props.theme.colors.greys.light};
      padding: 8px;
      text-align: left;
    }

    th:first-child,
    td:first-child {
      border-left: none;
    }

    th:last-child,
    td:last-child {
      border-right: none;
    }

    thead {
      background-color: ${(props) => props.theme.colors.greys.lighter};
    }
  }

  p {
    margin: 0;
  }
`;

export const ChartContainer = styled.div`
  background-color: ${(props) => props.theme.colors?.greys?.lighter};
  border-radius: 4px;
  padding: 8px;
`;

export const FeedbackIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const ScoreContainer = styled.div`
  position: absolute;
  bottom: -16px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.theme.colors.greys.light};
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  opacity: 1;
`;

export const FeedbackContainer = styled.div`
  position: absolute;
  bottom: -16px;
  right: 8px;
  display: flex;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;

  ${MessageContainer}:hover & {
    opacity: 1;
  }
`;

export const FeedbackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.greys.lighter};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DownloadContainer = styled.div`
  position: absolute;
  top: -16px;
  right: 8px;
  display: flex;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.greys.light};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;

  ${MessageContainer}:hover & {
    opacity: 1;
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.greys.lighter};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DownloadIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const RetryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;
